interface Config {
  apiUrl: string;
}

const config: Config = {  //https://api.elm.tj
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.elm.tj',
  //apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
};

export default config; 
